import { Action } from 'redux';

export enum NavigationActions {
  SET_NAVIGATE_STUDENT_RECORD = 'SET_NAVIGATE_STUDENT_RECORD',
}

export interface NavigateAction extends Action {
  payload: {
    navigateStudentRecord: boolean;
  };
}

export const setNavigateStudentRecordAction = (navigateStudentRecord: boolean): NavigateAction => ({
  type: NavigationActions.SET_NAVIGATE_STUDENT_RECORD,
  payload: { navigateStudentRecord },
});
